<template>
  <v-badge v-if="amount || persistent"
    :color="backgroundColor" inline
    :class="amount ? `content-digits-${ amount.toString().split('').length }` : ''"
    class="pa-0 mx-0">
    <span class="content">{{ amount || '0'}}</span>
  </v-badge>
</template>

<script>
import { textColor } from '@/lib/helpers/ColorUtils'
export default {
  props: {
    amount: Number,
    persistent: Boolean,
    themeColor: String,
  },
  computed: {
    backgroundColor () {
      return this.themeColor || 'primary'
    },
    textColor () {
      return textColor(this.$vuetify.theme.themes.light[this.themeColor].base)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-badge {
    position: relative;
  }
  .v-badge__wrapper {
    margin: 0 !important;
    padding: 0 !important;
    display: flex;
    align-items: center;
  }
}
.content-digits-2::v-deep {
  .v-badge__badge {
    padding: 0 14px;
  }
}
.content-digits-3::v-deep {
  .v-badge__badge {
    padding: 0 18px;
  }
}
.content-digits-4::v-deep {
  .v-badge__badge {
    padding: 0 22px;
  }
}
.content-digits-5::v-deep {
  .v-badge__badge {
    padding: 0 26px;
  }
}
.content {
  position: absolute;
  z-index: 1;
  color: white;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  padding: 0 !important;
  font-size: 12px;
  text-align: center;
  font-weight: bold;
}
</style>
